module.exports = __webpack_public_path__ + "img/K6403185.f5777228.jpg";